import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { SiteSettingsProvider } from "./context/SiteSettingsContext";
import ToastContainer from "./components/base/ToastContainer";
import LoadingScreen from "./components/base/LoadingScreen";
import WhatsAppButton from "./components/feature/WhatsAppButton";
import ScrollToTop from "./components/base/ScrollToTop";


function App() {
  return (
    <SiteSettingsProvider>
      <ToastProvider>
        <AuthProvider>
          <CartProvider>
            <LoadingScreen />
            <BrowserRouter basename={__BASE_PATH__}>
              <ScrollToTop />
              <AppRoutes />
            </BrowserRouter>
            <ToastContainer />
            <WhatsAppButton />
          </CartProvider>
        </AuthProvider>
      </ToastProvider>
    </SiteSettingsProvider>
  );
}

export default App;